import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { Dropdown, Menu } from 'antd';
import { BsLock, BsUnlock } from 'react-icons/bs';
import { IWalletProps } from '../../../utils/@types/wallet';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#FFF',
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export interface IPropsException {
  corretora: string;
  key: string;
  type: string;
  value: number;
}

export interface IPropsActive {
  Exception: IPropsException[];
  ValorExp: number;
  aportarQtde: number;
  closingPrice: number;
  corporationName: string;
  equitiesQuantity: number;
  novoupdateValue: number;
  percent: number;
  tickerSymbol: string;
  updateValue: number;
  reservadeemergencia: boolean;
  productTypeName: string;

  porcentagem_recomendada?: number;
  porcentagem_recomendada_tipo?: number;
  value?: number;
}

interface IPrpopsRenderConditionalObective {
  active: IPropsActive;
  exceptions: IPropsException[];
  filterBrokerage: string;
  setRule: Function;
  setShowModalCreateRule: Function;
  walletValues: IWalletProps;
  action?: boolean;
  fii?: boolean;
  typeWallet?: boolean;
  /** Quando true, ignora a distinção por tipo/corretora e resolve o objetivo
   * sempre pela regra `type === 'all'` (carteira unificada /wallet). */
  forceAllType?: boolean;
}

export function RenderConditionalObjective({
  exceptions = [],
  active,
  filterBrokerage,
  setRule,
  setShowModalCreateRule,
  walletValues,
  action = false,
  fii = false,
  forceAllType = false,
}: IPrpopsRenderConditionalObective) {
  if (fii && !forceAllType) {
    const allReadyExistException = exceptions.find(
      (exception) => exception.type === 'fii'
    );

    if (!allReadyExistException) {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Criar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsUnlock
              onClick={() => {
                const objectiveValue =
                  active.porcentagem_recomendada_tipo ??
                  active.porcentagem_recomendada ??
                  walletValues.objetivoFII ??
                  0;

                setRule({
                  ...active,
                  value: objectiveValue,
                  ValorExp: objectiveValue,
                  typeEdit: 'fii',
                });

                setShowModalCreateRule(true);
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {walletValues.objetivoFII.toFixed(2)}%
        </StyledTableCell>
      );
    } else {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Editar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsLock
              onClick={() => {
                setRule({
                  ...active,
                  value: allReadyExistException.value,
                  ValorExp: allReadyExistException.value,
                  exceptionKey: allReadyExistException.key,
                  edit: true,
                  typeEdit: 'fii',
                });

                setShowModalCreateRule(true);
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {allReadyExistException.value.toFixed(2)}%
        </StyledTableCell>
      );
    }
  }
  if (action && !forceAllType) {
    const allReadyExistException = exceptions.find(
      (exception) => exception.type === 'action'
    );
    if (!allReadyExistException) {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Criar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsUnlock
              onClick={() => {
                setShowModalCreateRule(true);
                setRule({ ...active, typeEdit: 'action' });
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {walletValues.objetivoAcao.toFixed(2)}%
        </StyledTableCell>
      );
    } else {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Editar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsLock
              onClick={() => {
                setShowModalCreateRule(true);
                setRule({
                  ...active,
                  edit: true,
                  typeEdit: 'action',
                });
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {allReadyExistException.value.toFixed(2)}%
        </StyledTableCell>
      );
    }
  }

  if (forceAllType || filterBrokerage === '') {
    // Mapeia o tipo do ativo para o tipo de regra que o backend usa ao fixar
    // a porcentagem_recomendada (acao→action, fii→fii, intl→stock/reit/etf);
    // renda fixa não tem regra própria e cai em 'all'. Com `forceAllType`, a
    // carteira unificada (/wallet) não distingue tipo: usa sempre 'all'.
    const RULE_TYPE_BY_PRODUCT: Record<string, string> = {
      acao: 'action',
      fii: 'fii',
      stock: 'stock',
      stocks: 'stock',
      reit: 'reit',
      reits: 'reit',
      etf: 'etf',
      etfs: 'etf',
    };
    const productRuleType =
      RULE_TYPE_BY_PRODUCT[active.productTypeName] ?? 'all';

    const allReadyExistException = forceAllType
      ? exceptions.find(
          (exception) => exception.type === productRuleType
        ) ??
        exceptions.find(
          (exception) => exception.type === 'all'
        )
      : exceptions.find(
          (exception) => exception.type === productRuleType
        );

    const ruleType =
      allReadyExistException?.type ?? productRuleType;


    // =============================================
    // DEBUG OBJETIVO / CADEADO
    // =============================================
    // if (
    //   active.tickerSymbol === 'LEVE3' ||
    //   active.tickerSymbol === 'CSUD3' ||
    //   active.tickerSymbol === 'HGCR11'
    // ) {
    //   console.log('===== DEBUG CADEADO OBJETIVO =====');
    //   console.log('ticker:', active.tickerSymbol);
    //   console.log('productTypeName:', active.productTypeName);
    //   console.log('forceAllType:', forceAllType);
    //   console.log('filterBrokerage:', filterBrokerage);
    //   console.log('productRuleType:', productRuleType);
    //   console.log('ruleType final:', ruleType);
    //   console.log('exceptions recebidas:', exceptions);
    //   console.log('regra encontrada:', allReadyExistException);
    //   console.log('ValorExp:', active.ValorExp);
    //   console.log(
    //     'porcentagem_recomendada:',
    //     active.porcentagem_recomendada
    //   );
    //   console.log('===================================');
    // }


    if (!allReadyExistException) {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Criar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsUnlock
              onClick={() => {
                setShowModalCreateRule(true);
                setRule({ ...active, typeEdit: ruleType });
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {active.ValorExp != null
            ? `${Number(active.ValorExp).toFixed(2)}%`
            : '-'}
        </StyledTableCell>
      );
    } else {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Editar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsLock
              onClick={() => {
                setShowModalCreateRule(true);
                setRule({
                  ...active,
                  edit: true,
                  typeEdit: ruleType,
                });
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {allReadyExistException.value.toFixed(2)}%
        </StyledTableCell>
      );
    }
  }
  if (!forceAllType && filterBrokerage !== '') {
    const allReadyExistExceptionBroker = exceptions.find(
      (exception) => exception.corretora === filterBrokerage
    );

    if (!allReadyExistExceptionBroker) {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Criar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsUnlock
              onClick={() => {
                setShowModalCreateRule(true);
                setRule({
                  ...active,
                  brokerEdit: filterBrokerage,
                  typeEdit: 'broker',
                });
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {active.ValorExp?.toFixed(2)}%
        </StyledTableCell>
      );
    } else {
      return (
        <StyledTableCell>
          <Dropdown
            overlay={
              <Menu
                style={{
                  maxWidth: '300px',
                }}
                items={[
                  {
                    key: '1',
                    label: <strong>Editar regra de exceção</strong>,
                  },
                  {
                    key: '2',
                    label: (
                      <strong>
                        Você poderá criar para cada ativo da sua carteira um
                        percentual especifico, que entrata como exceção na
                        distribuição automática dos ativos.
                      </strong>
                    ),
                  },
                ]}
              />
            }
            placement="bottom"
          >
            <BsLock
              onClick={() => {
                setShowModalCreateRule(true);
                setRule({
                  ...active,
                  edit: true,
                  typeEdit: 'broker',
                  brokerEdit: filterBrokerage,
                });
              }}
              size={20}
              style={{ cursor: 'pointer' }}
            />
          </Dropdown>
          {allReadyExistExceptionBroker.value.toFixed(2)}%
        </StyledTableCell>
      );
    }
  }
}
